var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Configurator } from '@api/services/configurator';
import { KissTariffsPassOption } from "@shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-option";
import { KissTariffsPassContent } from "@shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-content";
var KissTariffsPassContainer = /*@__PURE__*/ (function () {
    function KissTariffsPassContainer(container, availablePassesIds) {
        this.availablePasses = [];
        this.TITLE_PLACEHOLDER = "PASSES_TITLE";
        this.passes = [];
        this.passContents = {};
        this.template = "<div class=\"mod-ep-kiss-tariffs__passes-headline h2 black\">" +
            this.TITLE_PLACEHOLDER +
            "                                        </div>" +
            "                                        <div class=\"ep-shop-tab-selection\">" +
            "                                            <ul role=\"tablist\">" +
            "                                            </ul>" +
            "                                        </div>" +
            "                                        <div class=\"mod-ep-kiss-tariffs__pass-contents\"" +
            "                                             id=\"tariff-{{{tariff.id}}}-pass-contents-container\">" +
            "                                    </div>";
        this.container = container;
        var title = this.container.dataset.containerTitle;
        var element = document.createElement("div");
        this.template = this.template.replace(this.TITLE_PLACEHOLDER, title);
        element.innerHTML = this.template;
        this.container.append(element);
        this.tariffId = +this.container.dataset.tariffId;
        this.init(availablePassesIds);
    }
    KissTariffsPassContainer.prototype.init = function (passesIds) {
        return __awaiter(this, void 0, void 0, function () {
            var toggleList, contentList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toggleList = this.container.querySelector("ul");
                        contentList = this.container.querySelector(".mod-ep-kiss-tariffs__pass-contents");
                        Array.prototype.slice.call(this.container.querySelectorAll(".pass-item")).forEach(function (container) {
                            var passId = +container.dataset.id;
                            if (passesIds.findIndex(function (id) { return id === passId; }) > -1) {
                                _this.passes.push([
                                    new KissTariffsPassOption(passId, container.dataset.icon, _this.handlePassChanged),
                                    new KissTariffsPassContent(passId, container.dataset.title, container.dataset.description, container.dataset.tooltipHeadline, container.dataset.tooltipContent)
                                ]);
                            }
                            else {
                                container.style.display = "none";
                            }
                        });
                        this.passes.forEach(function (pass) {
                            toggleList.appendChild(pass[0].render());
                            contentList.appendChild(pass[1].render());
                        });
                        Configurator.subscribe('offerChanged', this.onOfferChanged.bind(this));
                        return [4 /*yield*/, this.onOfferChanged()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsPassContainer.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tariffId, offer, usedPass_1, available;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tariffId = Configurator.getTariff().id;
                        if (!(this.tariffId === tariffId))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _a.sent();
                        usedPass_1 = offer.getUsedPass();
                        if (usedPass_1) {
                            available = this.passes.findIndex(function (pass) { return pass[0].passId === usedPass_1.id; }) > -1;
                            if (available) {
                                this.updatePassSelected(usedPass_1.id);
                            }
                            else {
                                // usedPass but not configured
                            }
                        }
                        else {
                            this.updatePassSelected();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    KissTariffsPassContainer.prototype.handlePassChanged = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var offer;
            return __generator(this, function (_a) {
                offer = Configurator.getOffer();
                if (offer.getUsedPass() && offer.getUsedPass().id === id) {
                    offer.cancelPass();
                }
                else {
                    offer.usePass(id);
                }
                return [2 /*return*/];
            });
        });
    };
    KissTariffsPassContainer.prototype.updatePassSelected = function (passId) {
        this.passes.forEach(function (pass) {
            pass[0].setSelected(passId && pass[0].passId === passId);
            pass[1].setSelected(passId && pass[1].passId === passId);
        });
    };
    return KissTariffsPassContainer;
}());
export default KissTariffsPassContainer;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-container.ts
// module id = null
// module chunks = 